/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  GET_UPLOAD_DOCUMENTS_CONFIG,
  PERSONAL_DETAILS_SUBMIT,
  SAVE_BENEFICIARY_ID,
  SAVE_SCREEN_NAME,
  SAVE_TRANSACTION_DETAILS,
  SEND_MONEY_SUBMIT,
  UPDATE_SEND_MONEY,
  UPDATE_VISION_CHECK_COUNT,
  UPLOAD_DOC_SUCCESS,
  UPLOAD_PHOTO_SUCCESS,
  SET_USER_OTHER_DETAILS,
  STORE_ONFIDO_ACCESS_TOKEN,
  CLEAR_ONFIDO_TOKEN,
  USER_FLOW_JUMP_TO,
  STORE_ONFIDO_ACCESS_TOKEN_ERROR,
  EMP_TYPE_PASS,
  DISABLE_PERSONAL_DETAILS_FILEDS,
  STORE_PAYMENT_METHOD,
  GET_ADDRESS_CONFIG,
  UPDATE_AADHAR_OTP_VERIFICATION_ATTEMPTS,
  SET_BENE_ADDITIONAL_INFO_VALUE,
  SET_SEND_MONEY_PAYLOAD,
  SET_PAYMENT_METHOD_PAYLOAD,
  SET_BENE_ADDRESS_FOR_PAYIN_METHODS
} from '../../action-contants';
import {
  getCookie,
  getNextScreen,
  sanitize,
  uploadDocReqObj,
  mergeArraysByParameter,
  networkCall,
  injectIntoDataLayer,
  generateUniqueSessionId
} from '../../../utils/library';
import {
  getAccountType,
  getNextScreenFromState,
  makeApiCall,
  setAadharDetails,
  setSavedAadharDetails
} from '../common/common-action';
import { API_URL, REQ_TIMEOUT, API_URL_V2, API_URL_V3, API_URL_V4 } from '../../../utils/config';
import { handleError, showMessage } from '../common-message/message-action';
import {
  INDIVIDUAL_PERSONAL_IMAGE,
  INDIVIDUAL_POI,
  TRANSACTION_INVOICE,
  CORPORATE,
  GOODS,
  SERVICE,
  INITIATED,
  REGISTERED,
  EU_REGION,
  INDIVIDUAL,
  STATUS_BEFORE_APPROVED,
  JUMIO_ENABLE_COUNTRY,
  SERVICE_UNAVAILABLE_MESSAGE_PART,
  SCREEN_NAME_DOCUMENT_UPLOAD,
  US,
  DISABLED_PAYMENTS_METHODS,
  GB
} from '../../../utils/constants';
import {
  FLOW_TYPE_ONBOARDING,
  KYC_METHOD_SELECTED,
  ADHAR_KYC,
  ID_VERIFICATION_STARTED,
  PERSONAL_DETAILS_FILLED
} from '../../../utils/constants/eventsConstants';
import { loadUserSession } from '../authentication/authentication-action';
import { updateTimelineConfig, changeScreen } from '../user-flow/user-flow-action';
import { disableLoader } from '../ui-trigger/ui-trigger-action';
import get from 'lodash/get';
import moment from 'moment';
import { store } from '../../../store';
import { logEvent } from '../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../utils/events/eventsConstants';
import { changeOnBoardingScreen } from '../onboarding';
import { REVAMPED_SCREENS } from '../../../screens/user-flow/individual/revampedUserFlow/utils/constants';
import { collectPOADocAction, toggleErrorModalMsg } from '../onboarding/new-onboarding-action';
import { getFlagValue, isFlagEnabled } from '../flagsmith';
import { BENE_V3_FIELDS } from '../../../screens/payee-details/payee_details_initializer';
import { APPLE_PAY_RETRY_MODAL_CONTENT } from '../../../components/payment-method-retry-modal/constants';

export function saveScreenName(data) {
  return {
    type: SAVE_SCREEN_NAME,
    data
  };
}

export function sendMoneySubmit(data) {
  return {
    type: SEND_MONEY_SUBMIT,
    data
  };
}

export function updateAadharOtpverificationAttempts(data) {
  return {
    type: UPDATE_AADHAR_OTP_VERIFICATION_ATTEMPTS,
    data
  };
}

export function updateSendMoney(data) {
  return {
    type: UPDATE_SEND_MONEY,
    data
  };
}

function personalDetailsSubmit(data) {
  return {
    type: PERSONAL_DETAILS_SUBMIT,
    data
  };
}

function uploadDocSuccess(data) {
  return {
    type: UPLOAD_DOC_SUCCESS,
    data
  };
}

function uploadPersonalPhotoSuccess(data) {
  return {
    type: UPLOAD_PHOTO_SUCCESS,
    data
  };
}

function saveBeneficiaryId(data) {
  return {
    type: SAVE_BENEFICIARY_ID,
    data
  };
}

export function updateBeneAdditionalInfoData(data) {
  return {
    type: SET_BENE_ADDITIONAL_INFO_VALUE,
    data
  };
}

export function updateBeneAddressForPayinMethodData(data) {
  return {
    type: SET_BENE_ADDRESS_FOR_PAYIN_METHODS,
    data
  };
}

export function setSendMoneyData(data) {
  return {
    type: SET_SEND_MONEY_PAYLOAD,
    data
  };
}
export function setPaymentMethodData(data) {
  return {
    type: SET_PAYMENT_METHOD_PAYLOAD,
    data
  };
}
function uploadDocConfig(data) {
  return {
    type: GET_UPLOAD_DOCUMENTS_CONFIG,
    data
  };
}

export function updateTransactionDetails(data) {
  return {
    type: SAVE_TRANSACTION_DETAILS,
    data
  };
}

export function updateVisionCheckCount() {
  return {
    type: UPDATE_VISION_CHECK_COUNT
  };
}
export function getAddressConfig(params) {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_ADDRESS_CONFIG });
      const { data } = await makeApiCall({
        withCredentials: true,
        url: `${API_URL}/country/address-config`,
        dispatch,
        GET_ADDRESS_CONFIG,
        method: 'get',
        params,
        handleError,
        type: 'commonAction'
      });
      if (data.success) {
        dispatch({ type: `${GET_ADDRESS_CONFIG}_SUCCESS`, payload: data.data });
      } else {
        dispatch({ type: `${GET_ADDRESS_CONFIG}_ERROR` });
      }
      return data;
    } catch (error) {
      dispatch({ type: `${GET_ADDRESS_CONFIG}_ERROR`, error });
    }
  };
}
export async function getCustomerTypeKYCType() {
  const url = `${API_URL}/remitter/kyc-type`;
  const {
    data: { data }
  } = await makeApiCall({ method: 'GET', url, withCredentials: true });

  return data;
}
export function empType() {
  return (dispatch) => {
    const url = `${API_URL}/instarem-objects/dropdown?type=EMPLOYMENT_PASS&country_code=MY&account_type=INDIVIDUAL`;
    makeApiCall({ url, withCredentials: true }).then((res) => {
      dispatch({ type: EMP_TYPE_PASS, data: res.data.data });
    });
  };
}

function setAddressStreet(countryCode, formData) {
  let form_data = { ...formData };
  if (countryCode === 'US' || countryCode === 'AU') {
    if (form_data.street_name === null) {
      form_data.street_name = form_data.street;
    }
    if (form_data.street_type === null) {
      form_data.street_type = form_data.street;
    }
  }
  return form_data;
}

function setStreetNameType(street, formData) {
  let form_data = { ...formData };
  form_data.street_name = street;
  return form_data;
}

export function setUserOtherDetails(data) {
  return {
    type: SET_USER_OTHER_DETAILS,
    data
  };
}

/**
 * fetches countries for 'Bank account countries'
 * Note: error handling is not done here.
 * @param {*} data
 * @param {*} bene_id
 */

export const fetchDropdownCountries =
  ({ url }) =>
  (dispatch) => {
    return makeApiCall({ url, withCredentials: true }).then(({ data: { data } }) => data);
  };

export const fetchBeneCurrencies =
  ({ url }) =>
  (dispatch) => {
    return makeApiCall({ url, withCredentials: true }).then(({ data: { data } }) => data);
  };

/**
 * sendMonyPatch is patch call for US flow for add recipent page.
 * this action gets called on sumbit button of payeeDetils.
 *
 * copy pasted this action from sendMoneyRequest action
 * @param {data} data the transactions details
 * @param {bene_id} bene_id beneficiary id
 */

//gets called on instsapoints apply
export function sendMoneyPatch(data, bene_id) {
  const { temp_transaction_id, ...formData } = data;

  const excludedFields = [
    'country_code',
    'transaction_config',
    'fx_rate_last_updated',
    'warning_message',
    'first_instarem_transaction',
    'regular_instarem_fx_rate',
    'proposed_instapoints_earned',
    'transaction_created_at',
    'transaction_status_code',
    'transaction_status_name',
    'remitter_bank_name',
    'remitter_bank_url',
    'remitter_country_code',
    'remitter_country_name',
    'beneficiary_first_name',
    'beneficiary_middle_name',
    'beneficiary_last_name',
    'beneficiary_full_name',
    'beneficiary_company_name',
    'beneficiary_bank_account_number',
    'beneficiary_bank_name',
    'beneficiary_routing_code_type_1',
    'beneficiary_routing_code_value_1',
    'beneficiary_routing_code_type_2',
    'beneficiary_routing_code_value_2',
    'beneficiary_routing_code_type_3',
    'beneficiary_routing_code_value_3',
    'beneficiary_country_code',
    'beneficiary_country_name',
    'instarem_bank_account_display_name',
    'instarem_bank_account_is_pg',
    'instarem_bank_account_routing_code_details',
    'instarem_bank_account_name',
    'instarem_bank_account_number',
    'instarem_bank_name',
    'instarem_bank_address',
    'client_email',
    'client_mobile_country_code',
    'client_mobile_number',
    'total_fee_amount',
    'family_maintenance_purpose_declaration'
  ];

  excludedFields.forEach((field) => delete formData[field]);

  formData.beneficiary_id = bene_id;
  formData.temp_transaction_id = temp_transaction_id;

  return async (dispatch) => {
    const url = `${API_URL}/remitter/send-money/${temp_transaction_id}`;
    const method = 'patch';
    const next_screen = dispatch(getNextScreenFromState());

    const response = await makeApiCall({
      method: method,
      url: url,
      withCredentials: true,
      data: sanitize({ ...formData, screen_name: next_screen })
    });

    const additionalInfo = get(response, 'data.data.additional_info', {});

    if (response && response.data && response.data.success) {
      if (method === 'post' && response.data.data) {
        dispatch(
          sendMoneySubmit({
            ...formData,
            ...response.data.data,
            instarem_bank_account_id: formData.instarem_bank_account_id
          })
        );
        dispatch(saveScreenName({ screen_name: next_screen }));
        //save bene_id only after sendmony in us flow
        dispatch(saveBeneficiaryId({ beneficiary_id: bene_id }));
      } else {
        dispatch(
          updateSendMoney({
            ...formData,
            temp_transaction_id,
            instarem_bank_account_id: formData.instarem_bank_account_id,
            ...{ additional_info: additionalInfo }
          })
        );
        dispatch(saveScreenName({ screen_name: next_screen }));
        //save bene_id only after sendmony in us flow
        dispatch(saveBeneficiaryId({ beneficiary_id: bene_id }));
      }
    }
    return response;
  };
}

export function sendMoneyRequest(temp_transaction_id, data, dataLayerObj, selectedBene) {
  return async (dispatch, getState) => {
    try {
      let url,
        method,
        formData = { ...data },
        state = getState();
      formData.transaction_tier = formData?.transaction_config?.tier;
      //If applyOfferDiscountId presents that means its a upsell transaction.
      if (formData.applyOfferDiscountId) {
        formData.upsell_offer_applied = true;
        delete formData.applyOfferDiscountId;
      }

      delete formData.country_code;
      delete formData.transaction_config;
      delete formData.fx_rate_last_updated;
      delete formData.warning_message;
      delete formData.total_fee_amount;
      delete formData.coupon_validation;
      delete formData.first_instarem_transaction;
      delete formData.regular_instarem_fx_rate;
      delete formData.proposed_instapoints_earned;
      /** Changed by Krunal - For deleting insta_points key */
      delete formData.insta_points;

      if (formData.cash_payout_location) {
        formData['additional_info']['cash_payout'] = {
          location_name: formData.cash_payout_location_name,
          location_code: formData.cash_payout_location
        };
      }
      delete formData.cash_payout_location_name;
      delete formData.cash_payout_location;

      if (formData.temp_transaction_id === '') delete formData.temp_transaction_id;

      ((formData.redeemed_instapoints && formData.redeemed_instapoints === '') ||
        !formData.redeemed_instapoints_amount) &&
        (formData.redeemed_instapoints = null);

      formData.redeemed_referral_rewards = null;
      formData.redeemed_referral_reward_amount = null;

      formData.coupon_code && !(formData.coupon_amount >= 0) && (formData.coupon_code = null);

      let utmCookie = getCookie('utm');
      if (utmCookie) utmCookie = JSON.parse(utmCookie);
      else utmCookie = {};
      formData = { ...formData, ...utmCookie };

      // setting screen name
      const {
        rootReducer: {
          userStatusReducer,
          userSessionReducer: {
            user_session: { country_code }
          },
          userFlowReducer: { currentScreen, dhaChallanData }
        }
      } = state;

      /**
       * if user is form US and in sginUp process
       * then redirect it to account details screen because we need payment_fee_details in sendMoney Patch call
       * else
       * getNextScreen
       */
      let next_screen = null;
      if (
        country_code === 'US' &&
        (userStatusReducer.status === REGISTERED || userStatusReducer.status === INITIATED)
      ) {
        next_screen = currentScreen;
      } else {
        next_screen = dispatch(getNextScreenFromState());
      }

      if (temp_transaction_id) {
        /**
         * If currency is changed then fire post request else patch
         */
        let { transactionDetails: td } = getState().rootReducer.transactionReducer;

        if (
          td.destination_currency !== formData.destination_currency ||
          td.source_currency !== formData.source_currency
        ) {
          method = 'post';
          url = `${API_URL}/remitter/send-money`;
          delete formData.temp_transaction_id;
          if (selectedBene?.is_dha_beneficiary && dhaChallanData) {
            formData.challan_number = dhaChallanData.challan_number;
            formData.is_source_oriented = false;
          }
        } else {
          method = 'patch';
          url = `${API_URL}/remitter/send-money/${temp_transaction_id}`;
          formData = { ...formData, temp_transaction_id: temp_transaction_id };
        }
      } else {
        method = 'post';
        url = `${API_URL}/remitter/send-money`;
        if (selectedBene?.is_dha_beneficiary && dhaChallanData) {
          formData.challan_number = dhaChallanData.challan_number;
          formData.is_source_oriented = false;
        }
      }

      let params = {
        method,
        url,
        withCredentials: true,
        data: sanitize({ ...formData, screen_name: next_screen })
      };

      let response = await networkCall(params, dispatch, formData, dataLayerObj);
      if (response && response.data && response.data.success) {
        if (method === 'post' && response.data.data) {
          dispatch(
            sendMoneySubmit({
              ...formData,
              ...response.data.data,
              instarem_bank_account_id: data.instarem_bank_account_id,
              selectedBene: selectedBene ? selectedBene : null
            })
          );
          dispatch(saveScreenName({ screen_name: next_screen }));
        } else {
          const additionalInfo = get(response, 'data.data.additional_info', {});
          dispatch(
            updateSendMoney({
              ...formData,
              ...{ additional_info: additionalInfo },
              temp_transaction_id,
              instarem_bank_account_id: data.instarem_bank_account_id
            })
          );
          dispatch(saveScreenName({ screen_name: next_screen }));
        }
      }
      return response;
    } catch (err) {
      dispatch(handleError(err));
      throw err;
    }
  };
}

export function personalDetailsSubmitRequest(props, additional_info, country_code, dataLayerObj) {
  return async (dispatch, getState) => {
    try {
      let state = getState(),
        screen_name,
        postData = { ...props };
      logEvent(PERSONAL_DETAILS_FILLED, FLOW_TYPE_ONBOARDING, {}, LOG_TYPE.CLEVER_TAP);
      if (props.date_of_birth && props.nationality) {
        let formattedAge = moment(props.date_of_birth, 'DD/MM/YYYY')?.fromNow()?.split(' ')[0];
        //age and nationality passing for user properties
        logEvent(
          PERSONAL_DETAILS_FILLED,
          FLOW_TYPE_ONBOARDING,
          {
            age: formattedAge,
            nationality: props.nationality
          },
          LOG_TYPE.GA
        );
      } else {
        logEvent(PERSONAL_DETAILS_FILLED, FLOW_TYPE_ONBOARDING, {}, LOG_TYPE.GA);
      }
      const {
        rootReducer: {
          documentDataReducer: { isDocsUploadedOrEVerifiedSuccess },
          userStatusReducer: {
            account_type: account_type_redux,
            status,
            country_code: countryCodeRedux
          },
          userFlowReducer: { screens, currentScreen },
          userDataReducer: {
            userAddressInfo: { disable_fields = '' }
          }
        }
      } = getState();
      if (country_code !== 'AU') {
        screen_name = getNextScreen(screens, currentScreen);
        postData = { ...props, screen_name };
      }
      const onfidoModalRequired =
        account_type_redux === INDIVIDUAL &&
        EU_REGION.includes(country_code) &&
        STATUS_BEFORE_APPROVED.includes(status);

      /**
       * if onfido is required and create check api is not fired with success then
       * donot send current screen name from person details **to next screen name**
       */
      if (onfidoModalRequired && !isDocsUploadedOrEVerifiedSuccess) {
        screen_name = 'personal_details';
        postData = { ...props, screen_name };
      }

      if (country_code !== 'IT') {
        delete postData.gender;
        delete postData.fiscal_code;
      }

      /**
       * Changed by Krunal
       * For Address API change
       */

      if (!disable_fields) {
        postData = setAddressStreet(countryCodeRedux, postData);
      }
      if (postData.street && !postData.street_name && !postData.street_type) {
        postData = setStreetNameType(postData.street, postData);
      } else if (disable_fields && !postData.street_name && !postData.street_type) {
        postData = setStreetNameType(postData.street, postData);
      }

      delete postData.mailing;
      delete postData.residential;
      delete postData.employer_name;
      delete postData.is_mailing_address_diff;
      !postData.employment_status_meta && delete postData.employment_status_meta;
      !postData.nature_of_self_employment && delete postData.nature_of_self_employment;
      delete postData.mobile_otp;
      delete postData.pan_number; // only for India
      // only for US
      delete postData.identity_number;
      delete postData.verify_with;
      delete postData.street; // for US and AU
      delete postData.disable_middle_name; // for AU
      let url, method;
      if (additional_info) {
        if (additional_info.mailing_address) delete additional_info.mailing_address.street;
        Object.keys(additional_info).forEach((key) => delete postData[key]);
        postData = { ...postData, additional_info };
      }
      if (postData.screen_name === 'jumio_verification') {
        postData.screen_name = 'individual_documents_upload';
      }

      url = `${API_URL}/remitter/individual/personal-details`;
      method = 'patch';
      let account_type_id = state.rootReducer.userSessionReducer.user_session.account_type_id,
        account_type = state.rootReducer.userSessionReducer.user_session.account_type;
      postData['remitter_' + account_type.toLowerCase() + '_id'] = account_type_id;
      postData['session_id'] = generateUniqueSessionId();
      let params = {
        method,
        url,
        withCredentials: true,
        data: sanitize(postData)
      };

      let response = await networkCall(params, dispatch, postData, dataLayerObj);
      if (method === 'patch') {
        //...getstate SAVE FORM DATA ON RESPONSE IN APPLICANT DETAILS
        dispatch(
          personalDetailsSubmit({
            ...postData,
            ...additional_info,
            account_type_id: response.data.data.account_type_id
          })
        );
      }
      if (response && response.data && response.data.success) {
        //update the timeline config
        if (
          postData.referred_by_referral_code &&
          !state.rootReducer.userSessionReducer.user_session.isReferralCodeSubmittedOnSignup
        ) {
          dispatch(loadUserSession({ isReferralCodeSubmittedOnPersonalDetails: true }));
          let timelineObj = state.rootReducer.userFlowReducer.timeline;
          let reqIndex = timelineObj.findIndex((x) => x.key === 'acknowledgement');
          if (reqIndex !== -1 && timelineObj[reqIndex].timeline_meta) {
            let instaPointsLogicData = state.rootReducer.userDataReducer.instaPointsLogicData;
            timelineObj[reqIndex].timeline_meta.heading.text = `Get ${
              instaPointsLogicData.welcome_instapoint +
              instaPointsLogicData.acknowledgement_instapoint +
              instaPointsLogicData.initial_referral_instapoint
            } IPs`;
            dispatch(updateTimelineConfig(timelineObj));
          }
        }
        response.data.data.disable_personal_details &&
          dispatch({ type: DISABLE_PERSONAL_DETAILS_FILEDS });
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
      return error.response;
    }
  };
}

/**onfido actions */
export function initalizeOnfido() {
  return async (dispatch) => {
    const url = `${API_URL}/onfido/intialize`;
    //clearing error if error exists while making new api call.
    dispatch({ type: STORE_ONFIDO_ACCESS_TOKEN_ERROR, data: false });
    try {
      const res = await makeApiCall({
        method: 'GET',
        url,
        withCredentials: true
      });
      if (res && res.data && res.data.success) {
        const {
          data: {
            documentDetails,
            onfidoDetails: { onfido_sdk_token, onfido_applicant_id }
          }
        } = res.data;
        dispatch({
          type: STORE_ONFIDO_ACCESS_TOKEN,
          data: {
            onfidoAccessToken: onfido_sdk_token,
            onfidoApplicantId: onfido_applicant_id,
            onfidoDocsToRender: documentDetails
          }
        });
      }
      return true;
    } catch (err) {
      dispatch({ type: STORE_ONFIDO_ACCESS_TOKEN_ERROR, data: true });
    }
  };
}

export function clearOnfidoToken() {
  return {
    type: CLEAR_ONFIDO_TOKEN
  };
}

export function onfidoSuccesCall(applicant_id) {
  return async (dispatch) => {
    const screen_name = dispatch(getNextScreenFromState());
    return await makeApiCall({
      method: 'POST',
      url: `${API_URL}/onfido/create-check`,
      withCredentials: true,
      data: {
        applicant_id,
        screen_name
      }
    });
  };
}

export function getCurrencies(country_code, account_type) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        url: `${API_URL}/beneficiary/currencies/dropdown?country_code=${country_code}&account_type=${account_type}`,
        withCredentials: true
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getBeneficiaryConfig(country_code, currency_code, account_type) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        // eslint-disable-next-line max-len
        url: `${API_URL_V2}/validation/routing?country_code=${country_code}&currency_code=${currency_code}&account_type=${account_type.toUpperCase()}`,
        withCredentials: true
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export const removeV3Fields = (postData) => {
  Object.keys(BENE_V3_FIELDS).forEach((key) => {
    delete postData[key];
  });
};

export function payeeDetailsSubmitRequest(
  props,
  beneficiary_routing_config_id,
  beneficiary_id,
  isIndependent,
  { is_partially_editable, is_completely_editable },
  dataLayerObj
) {
  return async (dispatch, getState) => {
    try {
      let method,
        url,
        postData = { ...props };
      let is_editable = is_partially_editable || is_completely_editable;
      let state = getState(),
        screen_name = getNextScreen(
          state.rootReducer.userFlowReducer.screens,
          state.rootReducer.userFlowReducer.currentScreen
        );
      if (!is_editable) postData = { ...postData, screen_name, beneficiary_routing_config_id };
      /**
       * Changed by Krunal
       * Change for Address API issue
       */
      const { country_code, account_type } = getState().rootReducer.userStatusReducer;
      const { disable_fields } = getState().rootReducer.userDataReducer.userAddressInfo;
      const user_account_type = account_type;

      if (!disable_fields) {
        postData = setAddressStreet(country_code, postData);
      }

      if (postData.street && !postData.street_name && !postData.street_type) {
        postData = setStreetNameType(postData.street, postData);
      } else if (disable_fields && !postData.street_name && !postData.street_type) {
        postData = setStreetNameType(postData.street, postData);
      }

      delete postData.disable_trade_name;

      delete postData.street;
      delete postData.social_credit_code;
      delete postData.organization_code;
      postData.account_type && postData.account_type.toUpperCase();
      delete postData.bank_card_validations;
      postData.bank_account && delete postData.bank_account;
      postData.debit_card && delete postData.debit_card;
      postData.show_visa_icon && delete postData.show_visa_icon;
      postData.beneficiary_routing_config_id_bank &&
        delete postData.beneficiary_routing_config_id_bank;
      postData.beneficiary_routing_config_id_debit &&
        delete postData.beneficiary_routing_config_id_debit;
      postData.fast_fund_message && delete postData.fast_fund_message;
      postData.payment_mode_supported && delete postData.payment_mode_supported;
      !postData.card_issuer_name && delete postData.card_issuer_name;
      delete postData.card_type;
      postData.bank_details_type && delete postData.bank_details_type;

      /** for edit beneficiary - changes done by krunal */
      postData.routing_config_type && delete postData.routing_config_type;
      postData.bank_account_number && delete postData.card_number;
      postData.card_number && delete postData.bank_account_number;
      postData.card_number && delete postData.bank_name;
      !postData.routing_code_value_1 && delete postData.routing_code_value_1;
      !postData.routing_code_value_2 && delete postData.routing_code_value_2;
      !postData.routing_code_value_3 && delete postData.routing_code_value_3;
      postData.beneficiary_routing_config_id = beneficiary_routing_config_id;
      postData.details_selected && delete postData.details_selected;
      delete postData.beneficiary_bank_name;

      removeV3Fields(postData);

      Object.keys(postData).forEach((key) => {
        if (postData[key] === null || postData[key] === undefined || postData[key] === '') {
          // us usd bene email mobile exempted from sanitization because they are optional so needs to be updated blank
          const isUSUSDBeneEmailMobile =
            ['email', 'mobile_number'].includes(key) &&
            postData.bank_account_country === 'US' &&
            postData.currency_code === 'USD';
          if (!isUSUSDBeneEmailMobile) {
            delete postData[key];
          }
        }
      });
      //Added country_code to null as country of residence is removed for Corporate Account
      if (
        user_account_type !== CORPORATE &&
        postData['account_type'] === CORPORATE &&
        ['SG'].includes(country_code)
      ) {
        postData['country_code'] = null;
      }

      if (beneficiary_id && (!isIndependent || is_editable)) {
        method = 'patch';
        url =
          is_partially_editable && !is_completely_editable
            ? `${API_URL}/remitter/beneficiary/${beneficiary_id}/update`
            : `${API_URL}/remitter/beneficiary/${beneficiary_id}`;
      } else {
        method = 'post';
        url = `${API_URL}/remitter/beneficiary`;
      }
      const finalData = sanitize(postData);
      const isUSUSDBene =
        postData.bank_account_country === 'US' && postData.currency_code === 'USD';
      if (isUSUSDBene) {
        if (!finalData['email']) finalData['email'] = postData['email'];
        if (!finalData['mobile_number']) finalData['mobile_number'] = postData['mobile_number'];
      }
      let params = {
        method: method,
        url: url,
        withCredentials: true,
        data: finalData
      };
      let response = await networkCall(params, dispatch, postData, dataLayerObj);
      if (response && response.data && response.data.success) {
        if (method === 'post' && isIndependent !== true) {
          const {
            rootReducer: {
              userStatusReducer,
              userSessionReducer: {
                user_session: { country_code }
              }
            }
          } = state;
          /**
           * if not Us and is in signup process, then only save bene data because logic for PayeeDetails will fail if we update bene_id here
           */
          if (
            !(
              country_code === 'US' &&
              (userStatusReducer.status === REGISTERED || userStatusReducer.status === INITIATED)
            )
          ) {
            dispatch(
              saveBeneficiaryId({
                beneficiary_id: response.data.data.beneficiary_id
              })
            );
          }
        }
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (error) {
      if (error.response.status === 460) {
        return { success: false, isAccountVerificationError: true };
      }
      if (error.response.status === 461) {
        return { success: false, isNameVerificationError: true, data: error.response.data?.data };
      }
      dispatch(handleError(error));
      return error.response;
    }
  };
}

export function markIsActiveBeneficiary(beneficiary_id, data) {
  return async (dispatch) => {
    try {
      const success = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/remitter/beneficiary/${beneficiary_id}/mark-isactive`,
        withCredentials: true,
        data: data
      });
      return success;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function submitPaymentMethodRequest(
  formVals,
  bank_id,
  temp_transaction_id,
  invoiceArray,
  addressFlow,
  isErrorFromApplePay
) {
  let formVal = { ...formVals };
  return async (dispatch) => {
    try {
      let additionalInfoObj = {};
      const obj = {
        amount: '',
        trade_order_id: '',
        trade_time: '',
        trade_currency: '',
        trade_amount: '',
        trade_name: '',
        trade_count: ''
      };
      if (formVal.reasonForTransferTradeType) {
        obj.amount = formVal.amount;
        obj.trade_order_id = formVal.trade_order_id;
        obj.trade_time = formVal.trade_time;
        obj.trade_currency = formVal.trade_currency;
        obj.trade_amount = formVal.trade_amount;
        obj.trade_name = formVal.trade_name;
        obj.trade_count = formVal.trade_count;
        if (formVal.reasonForTransferTradeType === GOODS) obj.goods_carrier = formVal.goods_carrier;
        if (formVal.reasonForTransferTradeType === SERVICE) {
          obj.service_detail = formVal.service_details;
          obj.service_time = formVal.service_time;
        }
        additionalInfoObj = { ...obj };
      }
      if (formVal.cash_payout_location) {
        additionalInfoObj['cash_payout'] = {
          location_name: formVal.cash_payout_location_name,
          location_code: formVal.cash_payout_location
        };
      }
      if (formVal.gift_occasion) {
        additionalInfoObj['gift_purpose_occasion'] = {
          occasion_id: formVal.gift_occasion,
          occasion_note: formVal.occassion_note
        };
      }

      if (formVal.stripePaymentId) {
        formVal.ipp_payment_method_id = formVal.stripePaymentId;
        delete formVal.stripePaymentId;
      }

      delete formVal.gift_occasion;
      delete formVal.occassion_note;
      delete formVal.cash_payout_location_name;
      delete formVal.cash_payout_location;
      delete formVal.reasonForTransferTradeType;
      delete formVal.goods_carrier;
      delete formVal.service_details;
      delete formVal.service_time;
      delete formVal.trade_type_code;
      delete formVal.beneficiary_routing_config_id_bank;
      delete formVal.beneficiary_routing_config_id_debit;
      delete formVal.bank_card_validations;
      delete formVal.details_selected;
      delete formVal.debit_card;
      Object.keys(obj).forEach((key) => delete formVal[key]);

      let postdata = { ...formVal };
      postdata = sanitize(postdata);
      // delete keys here and move them to additional_info

      delete postdata.initData;
      delete postdata.country_code; //generated during bankdetails validation
      //delete unwanted data end

      //screen_name to be added
      let formData = new FormData();
      // setting screen name
      let next_screen = dispatch(getNextScreenFromState());
      postdata = { ...postdata, screen_name: next_screen };

      if (bank_id) {
        postdata = { ...postdata, instarem_bank_account_id: bank_id };
      }
      // only for invoice

      let reqInvoiceArray = [];
      Object.keys(postdata).forEach((key) => {
        if (postdata[key] && key.indexOf('invoice') > -1) {
          /* append a file using FormData */
          let fileInfo = postdata[key];
          let extension = null;
          if (fileInfo.type) {
            extension = fileInfo.type;
          } else return;
          if (fileInfo.name) {
            formData.append(key, fileInfo, fileInfo.name);
          } else {
            extension = '.' + extension.split('/')[1];
            formData.append(key, fileInfo, key + extension);
          }
          let currentInvoiceData = invoiceArray.find((item) => item.fileName === key);
          if (currentInvoiceData && currentInvoiceData.document_detail_id) {
            reqInvoiceArray.push({
              fieldname: key,
              document_detail_id: currentInvoiceData.document_detail_id
            });
          } else {
            reqInvoiceArray.push({ fieldname: key });
          }
        } else if (postdata[key] !== null) {
          if (typeof postdata[key] === 'object' && !(postdata[key] instanceof File)) {
            // if data is an object
            formData.append(key, JSON.stringify(postdata[key]));
          } else {
            // if it's a string or a File object
            formData.append(key, postdata[key]);
          }
        }
      });
      let reqFileArray = [];
      reqInvoiceArray.forEach((key) => {
        /**
         * following fun returns the requested obj format that needs to be sent to the BE
         * uploadDocReqObj({fieldName, type, code, fieldData, otherFieldsData})
         */
        let reqestedData = {
          fieldName: key.fieldname,
          type: TRANSACTION_INVOICE,
          code: 'CORPORATE_TRANSACTION_INVOICE',
          fieldData: {},
          otherFieldsData: {
            document_detail_id: key.document_detail_id || null,
            is_KYC_oriented: true,
            is_transaction_oriented: false
          }
        };
        let respObj = uploadDocReqObj(reqestedData);
        reqFileArray.push(respObj);
      });

      let reqFileArrayData = JSON.stringify(reqFileArray);
      formData.append('documents', reqFileArrayData);
      if (postdata?.invoice_number && postdata?.invoice_date) {
        formData.append('invoice_number', postdata.invoice_number);
        formData.append('invoice_date', postdata.invoice_date.split('/').reverse().join('-'));
      }
      if (Object.keys(additionalInfoObj).length > 0)
        formData.append('additional_info', JSON.stringify(additionalInfoObj));
      let response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/transaction/${temp_transaction_id}/payment-method`,
        withCredentials: true,
        data: formData,
        timeout: REQ_TIMEOUT
      });
      if (!response) return { message: 'no response' };
      if (response.data && response.data.success) {
        if (!response.data.data.error) {
          // in case on plaid error
          //concatenate response array and requested array to initialize data in the upload documents resux form
          let arr1 = response.data.data.documents;
          let arr2 = [...reqFileArray];
          for (let i in arr1) {
            for (let j in arr2) {
              if (
                arr1[i]['document_code'] === arr2[j]['code'] &&
                arr1[i]['fieldname'] === arr2[j]['fieldname']
              ) {
                //store document details of resp obj
                arr1[i].details = arr2[j]['details'];
                arr1[i].type = TRANSACTION_INVOICE;
              }
            }
          }
          dispatch(uploadDocSuccess(arr1));
          dispatch(updateTransactionDetails(formVals));
          dispatch(saveScreenName({ screen_name: next_screen }));
        }
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (err) {
      if (isErrorFromApplePay) {
        if (err?.response?.status === 470) {
          return {
            success: false,
            errorTitle: 'Card not supported',
            errorBody: err.response.data?.data?.message
          };
        } else {
          return {
            success: false,
            errorTitle: APPLE_PAY_RETRY_MODAL_CONTENT.title,
            errorBody: APPLE_PAY_RETRY_MODAL_CONTENT.body
          };
        }
      }
      dispatch(handleError(err));
      let { response } = err;
      return response || err;
    } finally {
      dispatch(disableLoader());
    }
  };
}

export function getInstaremBankAccountsForCorp(source_currency) {
  return async (dispatch, getState) => {
    try {
      let country_code = getState().rootReducer.userSessionReducer.user_session.country_code;
      if (!source_currency)
        source_currency =
          getState().rootReducer.transactionReducer.transactionDetails.source_currency;
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/instarem-bank-accounts?country_code=${country_code}&currency_code=${source_currency}`,
        withCredentials: true,
        timeout: REQ_TIMEOUT
      });
      if (!response) return { message: 'no response' };
      return response;
    } catch (err) {
      dispatch(handleError(err));
      let { response } = err;
      return response || err;
    }
  };
}
export function getInstaremBankAccounts(source_currency) {
  return async (dispatch, getState) => {
    try {
      const {
        rootReducer: {
          transactionReducer: {
            transactionDetails: {
              source_currency: sourceCurrency,
              gross_source_amount: sourceAmount,
              destination_currency: destinationCurrency
            }
          }
        }
      } = getState();
      if (!source_currency) source_currency = sourceCurrency;
      let response = await makeApiCall({
        method: 'get',
        // eslint-disable-next-line max-len
        url: `${API_URL_V2}/payment-method?source_amount=${sourceAmount}&source_currency=${source_currency}&destination_currency=${destinationCurrency}`,
        withCredentials: true,
        timeout: REQ_TIMEOUT
      });
      if (!response) return { message: 'no response' };

      const disabledMethods = isFlagEnabled(DISABLED_PAYMENTS_METHODS)
        ? getFlagValue(DISABLED_PAYMENTS_METHODS)
        : [];

      if (response.data?.data) {
        response = {
          ...response,
          data: {
            ...response.data,
            data: response.data?.data?.filter(
              (paymentMethod) => !disabledMethods.includes(paymentMethod.code)
            )
          }
        };
      }
      let {
        data: { data }
      } = response;
      dispatch({ type: STORE_PAYMENT_METHOD, response: data }); // to show message in us, payment_method, send_money etc.
      return response;
    } catch (err) {
      dispatch(handleError(err));
      let { response } = err;
      return response || err;
    }
  };
}

export function uploadDocDetailsNew(
  files,
  documents,
  dataLayerObj,
  toggleFeature,
  skip_vision_check,
  is_tiered_kyc,
  employment_pass
) {
  return async (dispatch) => {
    try {
      let payloadObj = new FormData();
      payloadObj.append('documents', JSON.stringify(documents));
      Object.keys(files).forEach((fileName) => {
        let extension = files[fileName].name
          ? files[fileName].name
          : `${fileName}.${files[fileName].type.split('/')[1]}`;
        payloadObj.append(fileName, files[fileName], extension);
      });
      let next_screen = dispatch(getNextScreenFromState());
      let lastScreen = null,
        currentScreen = null,
        timeLine = null;
      let callApi = true;
      let url = `${API_URL}/remitter/individual/document-upload`;
      if (toggleFeature) {
        lastScreen = dataLayerObj.props.last_doc_screen;
        currentScreen = dataLayerObj.props.currentDocScreen.key;
        timeLine = dataLayerObj.props.currentDocTimeLine;
        callApi = dataLayerObj.props.call_doc_upload_api;
        if (lastScreen !== currentScreen) {
          next_screen = 'individual_documents_upload';
        }
        if (currentScreen === 'PERSONAL_IMAGE') {
          payloadObj.append('skip_vision_check', skip_vision_check);
          url = `${API_URL}/remitter/individual/image-upload`;
        }
      }
      const reduxData = store.getState();
      const { country_code, account_type } = reduxData?.rootReducer?.userStatusReducer || '';
      payloadObj.append(
        'screen_name',
        [US, GB].includes(country_code) && account_type === INDIVIDUAL
          ? SCREEN_NAME_DOCUMENT_UPLOAD
          : next_screen
      );
      let filesArray = Object.entries(files);
      payloadObj.append('session_id', generateUniqueSessionId());
      if (is_tiered_kyc) {
        payloadObj.append('is_tiered_kyc', is_tiered_kyc);
      }
      if (employment_pass) {
        payloadObj.append('employment_pass', employment_pass);
      }
      const apiCallNeededWithoutFile =
        Array.isArray(documents) &&
        documents.length === 1 &&
        documents[0].code === 'PERSONAL_IDENTIFICATION_NUMBER' &&
        documents[0].type === 'INDIVIDUAL_POI';
      if ((filesArray.length > 0 || apiCallNeededWithoutFile) && callApi) {
        let params = {
          method: 'patch',
          url: url,
          withCredentials: true,
          data: payloadObj,
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: REQ_TIMEOUT
        };
        let response = await networkCall(params, dispatch, payloadObj, dataLayerObj, false);

        if (response && response.data && response.data.success) {
          const { documents } = response.data.data;
          if (documents) {
            const reduxStore = store.getState();
            const isNewUIEnabled = get(
              reduxStore,
              'rootReducer.newUserFlowReducer.new_onboarding_enabled_users',
              false
            );
            if (!isNewUIEnabled) {
              logEvent(ID_VERIFICATION_STARTED, FLOW_TYPE_ONBOARDING);
            }
          }
          let unique = [];
          let res = response.data.data.documents;
          res.forEach((item) => {
            unique.push(item.document_code);
          });

          let docs = [...new Set(unique)];
          let doc_count = docs.length;

          dataLayerObj = {
            ...dataLayerObj,
            ...payloadObj,
            docs,
            doc_count
          };
          injectIntoDataLayer(dataLayerObj.formID, dataLayerObj);
          dispatch(
            uploadDocSuccess(
              mergeArraysByParameter(documents, response.data.data.documents, 'fieldname')
            )
          );
        } else {
          dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
        }
        return response;
      } else {
        let data = { success: true };
        if (toggleFeature && lastScreen !== currentScreen) {
          let currentScreenIndex = 0;
          timeLine.forEach((item, index) => {
            if (item.key.includes(currentScreen)) {
              currentScreenIndex = index;
              return false;
            }
          });
          data['next_screen'] = timeLine[currentScreenIndex + 1].key;
        }
        let response = { data };
        return response;
      }
    } catch (err) {
      dispatch(handleError(err));
      return err;
    }
  };
}

export function uploadPersonalPic(getFormDetails, is_vision_check_required, code) {
  return async (dispatch, getState) => {
    try {
      let vision_doc_code = null,
        documentPhotoId = null;
      const formData = new FormData();
      // setting screen name
      let next_screen = dispatch(getNextScreenFromState());

      let documentDetails = getState().rootReducer.documentDataReducer.documentDetails;
      let poiDocumentDetails = documentDetails.find((item) => item.type === INDIVIDUAL_POI);
      if (poiDocumentDetails && poiDocumentDetails.document_code) {
        vision_doc_code = poiDocumentDetails.document_code;
      }

      let formDetails = { ...getFormDetails },
        reqestedData = null,
        photoUploadObj = null;

      if (formDetails && Object.keys(formDetails).length > 0) {
        Object.keys(formDetails).forEach((subItem) => {
          if (formDetails[subItem] instanceof File || formDetails[subItem] instanceof Blob) {
            /* append a file using FormDetails */
            let fileInfo = formDetails[subItem];
            let extension = fileInfo.type;
            if (fileInfo.name) {
              formData.append('personal_image', fileInfo, fileInfo.name);
            } else {
              extension = '.' + extension.split('/')[1];
              formData.append('personal_image', fileInfo, 'personal_image' + extension);
            }
          }
          /**
           * following fun returns the requested obj format that needs to be sent to the BE
           * uploadDocReqObj({fieldName, type, code, fieldData, otherFieldsData})
           */
          reqestedData = {
            fieldName: 'personal_image',
            type: INDIVIDUAL_PERSONAL_IMAGE,
            code,
            fieldData: {},
            otherFieldsData: {
              document_detail_id: documentPhotoId,
              is_KYC_oriented: true,
              is_transaction_oriented: false,
              vision_doc_code
            }
          };
          photoUploadObj = uploadDocReqObj(reqestedData);
        });
      }

      let requestObj = photoUploadObj ? [photoUploadObj] : [];
      requestObj = JSON.stringify(requestObj);

      formData.append('documents', requestObj);
      formData.append('screen_name', next_screen);
      formData.append('skip_vision_check', is_vision_check_required);
      logEvent(ID_VERIFICATION_STARTED, FLOW_TYPE_ONBOARDING);
      let response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/remitter/individual/image-upload`,
        withCredentials: true,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: REQ_TIMEOUT
      });
      if (!response) return { message: 'no response' };
      if (response && response.data && response.data.success) {
        let arr1 = response.data.data.documents;
        let arr2 = [photoUploadObj];
        for (let i in arr1) {
          for (let j in arr2) {
            if (arr1[i]['document_code'] === arr2[j]['code']) {
              //store document details of resp obj
              arr1[i].details = arr2[j]['details'];
              arr1[i].type = arr2[j].type;
            }
          }
        }
        dispatch(updateVisionCheckCount());
        dispatch(uploadPersonalPhotoSuccess(arr1));
      } else {
        dispatch(updateVisionCheckCount());
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (err) {
      dispatch(updateVisionCheckCount());
      dispatch(handleError(err));
      let { response } = err;
      return response || err;
    }
  };
}

export function uploadPersonalPicNew(files, documents, skip_vision_check) {
  return async (dispatch) => {
    try {
      let payloadObj = new FormData();
      payloadObj.append('documents', JSON.stringify(documents));
      Object.keys(files).forEach((fileName) => {
        let extension = files[fileName].name
          ? files[fileName].name
          : `${fileName}.${files[fileName].type.split('/')[1]}`;
        payloadObj.append(fileName, files[fileName], extension);
      });
      let next_screen = dispatch(getNextScreenFromState());
      payloadObj.append('screen_name', next_screen);
      payloadObj.append('session_id', generateUniqueSessionId());
      payloadObj.append('skip_vision_check', skip_vision_check);
      logEvent(ID_VERIFICATION_STARTED, FLOW_TYPE_ONBOARDING);
      let response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/remitter/individual/image-upload`,
        withCredentials: true,
        data: payloadObj,
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: REQ_TIMEOUT
      });
      if (response && response.data && response.data.success) {
        dispatch(
          uploadDocSuccess(
            mergeArraysByParameter(documents, response.data.data.documents, 'fieldname')
          )
        );
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (err) {
      dispatch(handleError(err));
      return err;
    }
  };
}

export function getUploadDocConfig(paramObject) {
  return async (dispatch, getState) => {
    const {
      rootReducer: {
        userFlowReducer: { screens, timeline },
        userSessionReducer: {
          user_session: { country_code }
        }
      }
    } = getState();
    try {
      let params = {};
      let screen_name;
      if (paramObject) {
        Object.keys(paramObject).forEach((key) => {
          if (key === 'screen_name') screen_name = paramObject[key];
          params[key] = paramObject[key];
        });
      }
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/country/document`,
        withCredentials: true,
        params: params
      });
      if (response && response.data && response.data.success) {
        let account_type = dispatch(getAccountType());
        /**
         * For EU regions if no getting documents, push him to ack screen
         */
        if (
          response.data.data.length === 0 &&
          EU_REGION.includes(country_code) &&
          account_type !== CORPORATE
        ) {
          dispatch(changeScreen(USER_FLOW_JUMP_TO, 'acknowledgement', screens, timeline));
        }
        if (screen_name && account_type === CORPORATE) {
          let reduxUploadDocConfig = getState().rootReducer.documentDataReducer.uploadDocConfig;
          dispatch(
            uploadDocConfig({
              ...reduxUploadDocConfig,
              [screen_name]: response.data.data
            })
          );
        } else {
          dispatch(uploadDocConfig(response.data.data));
        }
        return response;
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function multipleTxnPaymentMethodSubmit(data, batchNo, instarem_bank_account_id) {
  return async (dispatch) => {
    try {
      data = { ...data, instarem_bank_account_id };
      let response = await makeApiCall({
        data,
        method: 'patch',
        url: `${API_URL}/batch/${batchNo}/payment-method`,
        withCredentials: true
      });
      response &&
        response.data &&
        !response.data.success &&
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      return response;
    } catch (error) {
      dispatch(handleError(error));
      dispatch(disableLoader());
    }
  };
}

export function fatcaSubmitRequest(props) {
  return async (dispatch) => {
    try {
      let screen_name = dispatch(getNextScreenFromState());
      let response = await makeApiCall({
        data: { ...props, screen_name },
        method: 'post',
        url: `${API_URL}/remitter/individual/fatca`,
        withCredentials: true
      });
      if (response && response.data) {
        if (response.data.success) {
          return response;
        } else if (response.data.data) {
          dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
        }
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
/**
 * function used for checking beneficiary registered status -  for cny beneficiary only
 * @param {integer} beneficiary_id accepts beneficiary_id as parameter to check the status
 * @return {Object} returns object of response from api
 */
export function checkBenificiaryStatus(beneficiary_id) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/remitter/beneficiary/${beneficiary_id}/is-bos-registered`,
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
/**
 * For visa cards
 */
export function saveNewBenificiary(beneficiary_id, otherProps) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/remitter/beneficiary/${beneficiary_id}`,
        data: { ...otherProps },
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getAmazeDetails() {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/amaze/details`,
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getPHPBankList(country_code, currency_code) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/routing-code/banklist?country_code=${country_code}&currency_code=${currency_code}`,
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
export const initiateJumioRequest = (data) => {
  return async (dispatch) => {
    const url = `${API_URL_V4}/ekyc/jumio/initiate`;
    try {
      let response = await makeApiCall({
        method: 'post',
        url,
        data,
        withCredentials: true
      });
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};
export const jumioSuccessRequest = (
  isRFI = false,
  rfiID = null,
  transactionReferenceId,
  accountId,
  kycType
) => {
  return async (dispatch) => {
    try {
      const url = `${API_URL_V4}/ekyc/jumio/complete`;

      let response = await makeApiCall({
        method: 'post',
        url: `${isRFI ? `${API_URL_V4}/ekyc/jumio/rfi/${rfiID}/complete` : url}`,
        withCredentials: true,
        data: {
          transactionReferenceId,
          accountId,
          ...(isRFI ? { kycType } : {})
        }
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export function getCashPayoutLocationList(country_code) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/routing-code/cashpayout-location?country_code=${country_code}`,
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getRefData(url) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL_V2}/${url}`,
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
export const getBankCodeORBranchNames = (country_code, bank_name) => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/routing-code/branchlist`,
        data: { country_code, bank_name },
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};
export const getIFSCBranches = () => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/routing-code/IN/country-bank-code`,
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};
export const getIFSCStates = (bank_code) => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/routing-code/entity/${bank_code}`,
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};
export const getIFSCCity = (bank_code, state) => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/routing-code/entity/${bank_code}?state=${state}`,
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};
export const getIFSCCode = (bank_code, state, city) => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/routing-code/entity/${bank_code}?state=${state}&city=${city}`,
        withCredentials: true
      });

      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export const generateAadharOTP = (data) => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/remitter/e-verify/aadhaar-otp`,
        withCredentials: true,
        data,
        timeout: 120000
      });
      if (response && response.data && response.data.success) {
        logEvent(
          KYC_METHOD_SELECTED,
          FLOW_TYPE_ONBOARDING,
          { kycType: ADHAR_KYC },
          LOG_TYPE.CLEVER_TAP
        );
        dispatch(
          setAadharDetails({
            ...data,
            stan: get(response, 'data.data.stan', false)
          })
        );
      }
      return {
        success: response.data.success,
        data: response.data.data
      };
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export const getCountryListNiumForex = () => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        url: `${API_URL}/public/remitter/countries/dropdown`,
        method: 'get',
        params: {
          is_residence_activated: true
        }
      });
      if (response && response.data) {
        return response.data.data;
      }
    } catch (err) {
      dispatch(handleError(err));
    }
  };
};

export const verifyAadharOTP = (data) => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/remitter/e-verify/aadhaar`,
        withCredentials: true,
        data,
        timeout: 120000
      });
      return get(response, 'data', {});
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export const confirmAadharDetails = (data = {}) => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/remitter/e-verify/aadhaar/consent`,
        withCredentials: true,
        data
      });
      if (response && response.data && response.data.success) {
        logEvent(
          KYC_METHOD_SELECTED,
          FLOW_TYPE_ONBOARDING,
          { kycType: ADHAR_KYC },
          LOG_TYPE.CLEVER_TAP
        );
        return true;
      }
      dispatch(
        showMessage({
          text: get(response, 'data.data.message', 'Something Went Wrong'),
          type: 'error'
        })
      );
      return false;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export function getRemitterAadharData() {
  return async (dispatch, getState) => {
    const state = getState();
    const isUserAuthenticated = get(
      state,
      'rootReducer.userSessionReducer.is_user_authenticated',
      false
    );
    if (isUserAuthenticated) {
      try {
        let response = await makeApiCall({
          method: 'get',
          url: `${API_URL}/remitter/aadhaar-details`,
          withCredentials: true
        });
        dispatch(setSavedAadharDetails(get(response, 'data.data', null)));
      } catch (error) {
        const message = error.response.data.data.message;
        if (message && message.includes(SERVICE_UNAVAILABLE_MESSAGE_PART)) {
          dispatch({ type: 'SERVICE_UNAVAILABLE' });
          return { success: false, isServiceUnavailable: true };
        } else {
          dispatch(handleError(error));
        }
      }
    }
  };
}

export const isJumioServiceAvailable = (countryCode, isEkycRFI = false) => {
  return async (dispatch) => {
    try {
      if (
        (isEkycRFI && EU_REGION.includes(countryCode)) ||
        JUMIO_ENABLE_COUNTRY.includes(countryCode)
      ) {
        const url = `${API_URL_V4}/ekyc/jumio/initiate`;
        const data = {
          serviceStatus: true
        };
        let response = await makeApiCall({
          method: 'post',
          url,
          withCredentials: true,
          data
        });
        return (
          get(response, 'data.success', false) || get(response, 'data.data.data.data.active', false)
        );
      } else return false;
    } catch (error) {
      return false;
    }
  };
};

export const dispatchOnfidoData = (onfidoResponse) => {
  return async (dispatch) => {
    dispatch({
      type: STORE_ONFIDO_ACCESS_TOKEN,
      data: {
        onfidoAccessToken: onfidoResponse?.onfidoAccessToken,
        onfidoApplicantId: onfidoResponse?.onfidoApplicantId,
        onfidoDocsToRender: onfidoResponse?.onfidoDocsToRender
      }
    });
  };
};

export const isOnfidoServiceAvailable = () => {
  return async (dispatch) => {
    try {
      //clearing error if error exists while making new api call.
      dispatch({ type: STORE_ONFIDO_ACCESS_TOKEN_ERROR, data: false });
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL_V3}/ekyc/onfido/initiate`,
        withCredentials: true
      });
      const responseData = response?.data?.data;
      if (responseData?.success) {
        const {
          data: { active, applicantId, documentDetails, sdkToken }
        } = responseData.data;
        return {
          isOnidoServiceActive: active,
          onfidoAccessToken: sdkToken,
          onfidoApplicantId: applicantId,
          onfidoDocsToRender: documentDetails
        };
      }
      return { isOnidoServiceActive: false };
    } catch (error) {
      dispatch({ type: STORE_ONFIDO_ACCESS_TOKEN_ERROR, data: true });
      if (error?.response?.status === 400) {
        const data = error.response.data?.data?.data;
        const keyName = data?.key;
        const type = data?.type;
        if (type === 'validation_error') {
          if (['address', 'pi'].includes(keyName)) {
            dispatch(
              toggleErrorModalMsg({
                showModal: true,
                message: data?.message || ''
              })
            );
            dispatch(
              changeOnBoardingScreen(
                keyName === 'address'
                  ? REVAMPED_SCREENS.addressInput
                  : REVAMPED_SCREENS.personalInformation
              )
            );
            return { noChangeScreenChange: true };
          }
        } else if (type === 'rate_limit') {
          return { rateLimitError: true, errorMsg: data?.message || '' };
        }
      }
      return { isOnidoServiceActive: false };
    }
  };
};

export const revampedOnfidoSuccessCall = (applicantId) => {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'POST',
        url: `${API_URL_V3}/ekyc/onfido/complete`,
        withCredentials: true,
        data: {
          applicantId
        }
      });
      if (response?.status === 200 && response?.data?.data?.success) {
        dispatch(collectPOADocAction(response?.data?.data?.data?.data?.isAddressVerified));
        return response?.data;
      }
      return false;
    } catch (error) {
      dispatch(handleError(error));
      return false;
    }
  };
};

export function fetchBeneConfigFromBeneService(country_code, currency_code, account_type) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        // eslint-disable-next-line max-len
        url: `${API_URL}/remitter/beneficiary/payouts?destination_currency=${currency_code}&destination_country=${country_code}&beneficiary_account_type=${account_type.toUpperCase()}`,
        withCredentials: true
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function payeeDetailsSubmitRequestNew(
  props,
  beneficiary_id,
  isIndependent,
  { is_partially_editable, is_completely_editable },
  dataLayerObj
) {
  return async (dispatch, getState) => {
    try {
      let method,
        url,
        postData = { ...props };
      let is_editable = is_partially_editable || is_completely_editable;
      let state = getState(),
        screen_name = getNextScreen(
          state.rootReducer.userFlowReducer.screens,
          state.rootReducer.userFlowReducer.currentScreen
        );
      if (!is_editable) postData = { ...postData, screen_name };

      postData.beneficiary_account_type = postData.account_type.toUpperCase();
      postData.destination_country = postData.bank_account_country;
      postData.destination_currency = postData.currency_code;
      postData.payout_method = postData.details_selected;
      delete postData.account_type;
      delete postData.bank_account_country;
      delete postData.currency_code;
      delete postData.mobile_country_code;

      postData.details_selected && delete postData.details_selected;

      Object.keys(postData).forEach((key) => {
        if (postData[key] === null || postData[key] === undefined || postData[key] === '') {
          delete postData[key];
        }
      });

      if (beneficiary_id && (!isIndependent || is_editable)) {
        method = 'patch';
        url = `${API_URL_V3}/remitter/beneficiary/${beneficiary_id}/payout/${beneficiary_id}`;
      } else {
        method = 'post';
        url = `${API_URL_V3}/remitter/beneficiary/create`;
      }
      const finalData = sanitize(postData);
      let params = {
        method: method,
        url: url,
        withCredentials: true,
        data: finalData
      };
      let response = await networkCall(params, dispatch, postData, dataLayerObj);
      if (response && response.data && response.data.success) {
        if (method === 'post' && isIndependent !== true) {
          const {
            rootReducer: {
              userStatusReducer,
              userSessionReducer: {
                user_session: { country_code }
              }
            }
          } = state;
          /**
           * if not Us and is in signup process, then only save bene data because logic for PayeeDetails will fail if we update bene_id here
           */
          if (
            !(
              country_code === 'US' &&
              (userStatusReducer.status === REGISTERED || userStatusReducer.status === INITIATED)
            )
          ) {
            dispatch(
              saveBeneficiaryId({
                beneficiary_id: response.data.data.beneficiary_id
              })
            );
          }
        }
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (error) {
      if (error.response.status === 460) {
        return { success: false, isAccountVerificationError: true };
      }
      if (error.response.status === 461) {
        return { success: false, isNameVerificationError: true, data: error.response.data?.data };
      }
      dispatch(handleError(error));
      return error.response;
    }
  };
}
